import React from 'react';
import { Spinner } from 'react-bootstrap';

import RelatorioTable from 'components/Relatorios/shared/RelatorioTable';

import useDecompSecaoParams from 'hooks/Relatorios/Decomp/useDecompSecaoParams';
import { useGetDecompCargaQuery } from 'services/api/products/relatorios';

export default function Carga() {
  const params = useDecompSecaoParams();

  const { data, isLoading } = useGetDecompCargaQuery(params);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  const columns = ['Subsistema', ...data.colunas];
  const rows = data.linhas.map((linha) => [linha.subsistema, ...linha.valores]);

  return <RelatorioTable titulo={data.titulo} columns={columns} rows={rows} />;
}
